import * as React from 'react'
import ModernNavbar from '../setup/ModernNavbar'
import { Container, Typography, Box, Grid2, Button, TextField, Divider } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination'
import Footer from '../setup/Footer'
import ErrorMsg from '../../BuiltInComponent/ErrorMsg'
import '../../services/GlobalVariables'
import { useSelector, useDispatch } from 'react-redux'
import { getEmployeeList, getEmployeeListReport } from '../../features/PayrollManagement/employeeSlice'
import EmployeeListReport from '../PayrollReports/EmployeeListReport'
import Loading from '../../BuiltInComponent/Loading'
import dayjs from 'dayjs'
export default function EmployeeRegistration() {

    let cnic
    const dispatch = useDispatch()
    const { employeeList, employeeListReport, isLoading } = useSelector((state) => state.emp)
    const { user } = useSelector((state) => state.auth)

    const navigate = useNavigate()

    React.useEffect(() => {
        dispatch(getEmployeeList())
        dispatch(getEmployeeListReport())
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'empID', cName: 'Emp ID', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'empImage', cName: 'Emp Pic', textAlign: 'left', width: '10%', dType: 'img', status: 'en' },
        { fieldName: 'empID', cName: 'ID', textAlign: 'left', width: '5%', dType: 'string', status: 'en' },
        { fieldName: 'entDate', cName: 'Joining Date', textAlign: 'left', width: '5%', dType: 'date', status: 'en' },
        { fieldName: 'empName', cName: 'Emp Name', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'empFName', cName: 'Emp Father Name', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'empCNIC', cName: 'Emp CNIC', textAlign: 'left', width: '20%', dType: 'string', status: 'en' },
        // { fieldName: 'status', cName: 'Emp Status', textAlign: 'center', width: '20%', dType: 'string', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '20%', status: 'en' },
        { fieldName: 'print', cName: 'Print', textAlign: 'center', width: '20%', status: 'dis' },
        { fieldName: 'print', cName: 'Print', textAlign: 'center', width: '20%', status: 'en', buttonText: 'Print' },
    ]

    const onEditClick = (empID) => {
        navigate('/EmployeeRegistration', { state: { empID: empID } })
    }

    const onPrintClick = (id) => {
        navigate('/EmployeeDetails', { state: { empID: id } })
    }
    const [err, setErr] = React.useState('')
    return (
        <>
            <ModernNavbar />
            <Container>
                <Box sx={{ background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(12,150,180,1) 100%)', mb: 3, mt: 10, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 30, fontWeight: 'bolder' }}>Employees List</Typography>
                </Box>
                <Grid2 container spacing={2}>
                    <Grid2 size={6}>
                        {/* <Typography>{err === '' ? '' : err}</Typography> */}
                        {err === '' ? <></> : <ErrorMsg message={global.msgError} msgColor='red' fontSize={'16px'} />}
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            variant='outlined'
                            label='Check with CNIC'
                            id='empCNIC'
                            name='empCNIC'
                            fullWidth
                            size='small'
                            onBlur={(event) => {
                                event.preventDefault()
                                cnic = employeeList.find((cnic) => cnic.empCNIC === event.target.value)

                                if (cnic) {
                                    setErr(`Employee Registered with Name ${cnic.empName}`)
                                    global.msgError = `Employee Registered with Name ${cnic.empName}`
                                    console.log(global.msgError)
                                } else {
                                    global.msgError = ''
                                }
                            }}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <Button
                            variant='contained'
                            fullWidth
                            sx={{ color: 'white', fontSize: 16, fontWeight: 'bolder' }}
                            onClick={(e) => {
                                e.preventDefault()
                                if (global.msgError === '') {
                                    navigate('/EmployeeRegistration')
                                } else {
                                }
                            }}
                        >
                            ADD NEW EMPLOYEE
                        </Button>
                    </Grid2>
                    <Grid2 size={12}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                            {isLoading ? <Loading /> : <><EmployeeListReport
                                data={employeeListReport && employeeListReport}
                                title="Employee List Report"
                                company="Maltex Exports"
                                fileName={`Employee List : ${dayjs(new Date()).format('DD-MMM-YYYY')}`}
                                reportDate={dayjs(new Date()).format('DD-MMM-YYYY')}
                                label="Print Report" />
                            </>
                            }
                        </Box>

                    </Grid2>
                    <Grid2 size={12}>
                        <Divider sx={{ mb: 2 }} />
                    </Grid2>
                </Grid2>
                <TableDataWithPagination tableColumns={tableColumns} tableData={employeeList && employeeList} onEditClick={onEditClick} onButtonClick={onPrintClick} user={user && user} />
            </Container>
            <Footer />
        </>
    )
}
